<template>
  <div
    v-if="isMounted"
    :key="settings.icon"
    class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
  >
    <statistics-card-line
      :icon="settings.icon"
      :statistic="settings.value"
      :statisticTitle="settings.label"
      type="area"
    ></statistics-card-line>
  </div>
</template>

<script>
import StatisticsCardLine from "./StatisticsCardLine.vue";
export default {
  data() {
    return {
      isMounted: false,
    };
  },
  components: {
    StatisticsCardLine,
  },
  props: {
    settings: Object,
    default: {},
  },
  created() {
    console.log("settings in stat:", this.settings);
    this.isMounted = true;
  },
};
</script>              